import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  incomplete: number,
 *  reviewRequired: number,
 *  followupRequired: number,
 *  contacted: number,
 *  approved: number }} ReviewLogStatusResponse
 */

const api = new Api("api/amo/reporting-status");

/**
 * @param {number} year
 * @returns {Promise<AxiosResponse<ReviewLogStatusResponse>>}
 */
export const getProjectReports = (year) => api.get(`projects/${year}`);

/**
 * @param {number} year
 * @returns {Promise<AxiosResponse<ReviewLogStatusResponse>>}
 */
export const getFinancialReports = (year) => api.get(`financials/${year}`);
